import { Route, Navigate } from 'react-router-dom'
import { OverviewPage } from './pages/OverviewPage'
import { SettingsPage } from './pages/SettingsPage'
import { ToDoPage } from './pages/ToDoPage'
import { PendingPage } from './pages/PendingPage'
import { DonePage } from './pages/DonePage'
import { InboxPage } from './pages/InboxPage'
import { EmailDetailPage } from './pages/EmailDetailPage'
import { PurchaseOrderDetailPage } from './pages/PurchaseOrderDetailPage'
import { UnmatchedOrderConfirmationPage } from './pages/UnmatchedOrderConfirmationPage'
import { SuppliersPage } from './pages/SuppliersPage'
import { SupplierSettingsPage } from './pages/SupplierSettingsPage'

/**
 * Children of the WorkflowPage route.
 * WorkflowPage renders OrderConfirmationLayout (Overview/Settings tabs + Outlet).
 */
export const orderConfirmationRoutes = (
  <>
    <Route index element={<Navigate to="overview/todo" replace />} />
    <Route path="overview" element={<OverviewPage />}>
      <Route index element={<Navigate to="todo" replace />} />
      <Route path="todo" element={<ToDoPage />} />
      <Route path="pending" element={<PendingPage />} />
      <Route path="done" element={<DonePage />} />
    </Route>
    <Route path="inbox" element={<InboxPage />} />
    <Route path="inbox/:emailId" element={<EmailDetailPage />} />
    <Route path="settings" element={<SettingsPage />} />
    <Route path="suppliers" element={<SuppliersPage />} />
    <Route path="suppliers/:supplierId/settings" element={<SupplierSettingsPage />} />
    <Route path="purchase-order/:purchaseOrderId" element={<PurchaseOrderDetailPage />} />
    <Route path="unmatched-oc/:orderConfirmationId" element={<UnmatchedOrderConfirmationPage />} />
  </>
)
